<template>
    <div class="editor">
        <Headline/>
        <h1 class="headLine">Editor</h1>
        <BackButton/>
        <div v-for="(answer, id) in answers" class="answer">
            <div v-if="collapsed(id)" v-html="answer.title" @click="expand(id)"
                 class="speechBubble-right collapsed fat"></div>
            <div v-else class="edit">
                <h3 class="editTitle" v-html="answer.title"></h3>
                <img class="collapseButton" src="@/assets/collapse-icon.png" @click="collapse(id)">
                <label :for="'short-' + id">Kurztitel</label>
                <input :id="'short-' + id" v-model="answer.short">

                <label :for="'title-' + id">Titel</label>
                <input :id="'title-' + id" v-model="answer.title">

                <label :for="'description-' + id">Pro-Argument</label>
                <textarea :id="'description-' + id" v-model="answer.description"></textarea>

                <label :for="'text-' + id">Text</label>
                <vue-editor :id="'text-' + id" v-model="answer.text"/>
            </div>
        </div>
        <label for="editorOutput">Generierter Code</label>
        <textarea id="editorOutput" ref="editorOutput" class="outputText" readonly>{{ getAnswers() }}</textarea>
        <button @click="copyToClipboard()">Kopieren</button>
        <button @click="downloadFile()">Download</button>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import {VueEditor} from "vue2-editor";
    import answers from "@/assets/answers";
    import Headline from "@/components/Headline";
    import BackButton from "@/components/BackButton";

    @Component({
        components: {BackButton, Headline, VueEditor},
    })
    export default class Editor extends Vue {

        data() {
            return {
                answers: answers,
                expanded: answers.map((answer, id) => false)
            }
        }

        collapsed(id) {
            return !this.expanded[id];
        }

        expand(id) {
            this.$set(this.expanded, id, true);
        }

        collapse(id) {
            this.$set(this.expanded, id, false);
        }

        getAnswers() {
            return JSON.stringify(answers);
        }

        copyToClipboard() {
            this.$refs.editorOutput.select();
            document.execCommand("copy");
            document.getSelection().empty();
        }

        downloadFile() {
            download("answers.js", this.getAnswers());
        }
    }

    function download(filename, text) {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

</script>
<style scoped lang="scss">
    @import "@/stylesheets/Variables.scss";
    @import "@/stylesheets/SpeechBubble.scss";

    .editor {
        $titleFontSize: 40px;

        width: 90vw;
        max-width: 1000px;
        margin: 0 auto;

        .headLine {
            font-weight: 900;
            text-align: left;
            font-size: $titleFontSize;
            font-variant: small-caps;
        }

        .label {
            font-weight: 900;
            text-align: left;
            font-size: $titleFontSize;
            font-variant: small-caps;
        }

        .answer {

            .collapsed {
                text-transform: uppercase;
                font-size: 24px;

                &:hover {
                    cursor: pointer;
                }
            }

            .edit {
                border: $border;
                margin-top: 70px;
                margin-bottom: 20px;
                padding: 15px;

                * {
                    display: block;
                }

                $transformTitle: -57px;

                .editTitle {
                    font-size: 36px;
                    font-variant: small-caps;
                    text-align: left;
                    position: relative;
                    top: $transformTitle;
                    margin-bottom: calc(#{$transformTitle} - 20px);

                }

                .collapseButton {
                    height: 25px;
                    width: 25px;
                    margin-left: calc(100% - 5px);
                    position: relative;
                    top: -18px;

                    &:hover {
                        cursor: pointer;
                    }
                }

                textarea {
                    width: 100%;
                    height: 200px;
                    font-size: 20px;
                }
            }
        }

        .text {
            font-size: 20px;
            line-height: 30px;

            padding: 15px;

            p {
                display: inline-block;
                text-align: left;
            }
        }

        .outputText {
            width: 100%;
            height: 300px;

            padding: 10px;
            border: $border;
            text-align: left;
            font-family: "Courier New", Courier, monospace;
        }
    }
</style>
<style lang="scss">

.editor {
  .edit {
    button {
      border: none !important;
    }
  }
}

</style>
